export const ActionTypes = {
  SET_REPORTING_LIST: 'SET_REPORTING_LIST',
  SET_FILTERS: 'SET_FILTERS',
};
